<template>
  <NotAvailable />

  <EventInfoBlock :booking="props.booking" :company="props.company" />
</template>

<script setup>
import NotAvailable from './NotAvailable.vue';
import EventInfoBlock from '../shared/EventInfoBlock.vue';

const props = defineProps({
  booking: {
    type: Object,
    default: () => ({}),
  },
  company: {
    type: Object,
    default: () => ({}),
  },
});
</script>
